// Material helpers
import '@material-ui/lab/themeAugmentation';
import {createTheme, Theme} from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';

export interface AppThemeType extends Theme {
}

export const AppTheme = createTheme({
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
  },
});


